import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import MidDropBox from '../../dnd/MidDropBox';

// Rows can be moved in a list to change the order.
function Sortable({ idParent, index, width, height, onDrop, afterSortable }) {
  const styleMidDropBox = {
    backgroundColor : `transparent`, zIndex: 20, position: `absolute`,
    width: width, height: height / 2
  }
  return (
    <>
      <MidDropBox accept={[`TRACK`, `CHART`, `TRACK-CARD`, `DECK`]} index={index - 1} idParent={idParent} drop={onDrop(idParent, index - 1, afterSortable)} style={{ ...styleMidDropBox, top: 0, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
      <MidDropBox accept={[`TRACK`, `CHART`, `TRACK-CARD`, `DECK`]} index={index} idParent={idParent} drop={onDrop(idParent, index, afterSortable)} style={{ ...styleMidDropBox, bottom: 0, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
    </>
  )
}

Sortable.propTypes = {
  idParent: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  onDrop: PropTypes.func.isRequired,
  afterSortable:  PropTypes.func
}

export default Sortable;
